module.exports = __webpack_public_path__ + "static/img/device_count3.e853486d.gif";